export enum RowDefinitionTypeEnum {
  Text = 'row-definition-text',
  Fullname = 'row-definition-fullname',
  FullnameShort = 'row-definition-fullname-short',
  FullnameInitials = 'row-definition-fullname-intials',
  Company = 'row-definition-company',
  Boolean = 'row-definition-boolean',
  Currency = 'row-definition-currency',
  Percent = 'row-definition-percent',
  Number = 'row-definition-number',
  BinaryStatus = 'row-definition-binary-status',
  Date = 'row-definition-date',
  CopyLink = 'row-definition-copy-link',
  Image = 'row-definition-image',
  LenderLogo = 'row-definition-lender-logo',
  LabeledImg = 'row-definition-labeled-image',
  DateWithTime = 'row-definition-date-with-time',
  DateTimeSince = 'row-definition-date-time-since',
  Address = 'row-definition-address',
  PropertyInvestmentType = 'property-investment-type',
  NotificationSettings = 'notification-settings',
  MortgageType = 'mortgage-type',
  DurationMonths = 'duration-months',
}
